module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/9200459659/result02-86c2e935e92700a966744b0059b76a4d.png";